import { api } from '@/lib/api/client';
import { demoCheckCoupon } from '@/pages/admin/demo/store/adminDemoStore';

/** Match admin demo mode — coupon validation runs against the local demo store. */
const USE_DEMO = true;

export interface Book {
  slug: string;
  title: string;
  author: string;
  price: number;
  oldPrice: number | null;
  category: string;
  stock: number;
  inStock: boolean;
  pages: number;
}

export function getBooks(): Promise<{ books: Book[] }> {
  return api.get<{ books: Book[] }>('/books').then((r) => r.data);
}

export interface Quote {
  items: { slug: string; title: string; price: number; icon: string | null; instructor: string }[];
  subtotal: number;
  bundles: { slug: string; title: string; discountPct: number; discount: number }[];
  bundleDiscount: number;
  couponCode: string | null;
  couponPct: number;
  couponDiscount: number;
  total: number;
}

export function getCartQuote(courseSlugs: string[], couponCode: string | null): Promise<Quote> {
  return api
    .post<Quote>('/cart/quote', { courseSlugs, couponCode: couponCode ?? undefined })
    .then((r) => r.data);
}

export function checkCoupon(
  code: string,
  opts?: { affiliateCode?: string | null; courseSlugs?: string[] },
): Promise<{
  valid: boolean;
  pct?: number;
  discountType?: 'percent' | 'flat';
  value?: number;
  audience?: 'public' | 'affiliate';
  message?: string;
}> {
  if (USE_DEMO) {
    return Promise.resolve(demoCheckCoupon(code, opts));
  }
  return api.get<{ valid: boolean; pct?: number }>(`/coupons/${code}`).then((r) => r.data);
}

export interface OrderResult {
  orderId: string;
  total: number;
  items: { slug: string }[];
}

export function createOrder(payload: {
  courseSlugs: string[];
  couponCode?: string;
  method: string;
  /** Active affiliate referral code from ?ref= attribution (optional). */
  affiliateCode?: string;
}): Promise<OrderResult> {
  return api.post<OrderResult>('/orders', payload).then((r) => r.data);
}

export interface BookOrderResult {
  orderId: string;
  total: number;
}

export function createBookOrder(payload: {
  items: { slug: string; qty: number }[];
  name: string;
  phone: string;
  address: string;
}): Promise<BookOrderResult> {
  return api.post<BookOrderResult>('/book-orders', payload).then((r) => r.data);
}
